import { render, staticRenderFns } from "./basePage.vue?vue&type=template&id=afc07c8c&"
import script from "./basePage.vue?vue&type=script&lang=js&"
export * from "./basePage.vue?vue&type=script&lang=js&"
import style0 from "./basePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports